'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Category = require('./Category');

var _Category2 = _interopRequireDefault(_Category);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLASS_NAME = 'categories';

function Categories(_ref) {
  var currentCategory = _ref.currentCategory,
      _handleClick = _ref.handleClick,
      categories = _ref.categories;

  return _react2.default.createElement(
    'div',
    { className: CLASS_NAME },
    categories.map(function (_ref2, key) {
      var label = _ref2.label,
          id = _ref2.id;
      return _react2.default.createElement(_Category2.default, {
        active: currentCategory === id,
        key: key,
        label: label,
        id: id,
        handleClick: function handleClick() {
          _handleClick(id);
          ga('send', 'event', 'Click', 'Match Toolbar', 'My ' + id.charAt(0).toUpperCase() + id.slice(1));
        }
      });
    })
  );
}
exports.default = Categories;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/Matcher/components/Categories.jsx
// module id = 1224
// module chunks = 0